<nav #navbar class="navbar active">
    <div class="container-fluid">
        <div class="navbar-header">
            <a href="#" onClick="return false;" class="navbar-toggle collapsed" data-toggle="collapse"
                data-target="#navbar-collapse" aria-expanded="false"></a>
            <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
            <a class="navbar-brand" routerLink="dashboard/main">
                <!-- <img src="assets/images/logo.png" alt="" /> -->
                <span class="logo-name">MES-LTD</span>
            </a>
        </div>
        <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="pull-left collapse-menu-icon">
                <li>
                    <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
                        <mat-icon>menu</mat-icon>
                    </button>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <!-- Full Screen Button -->
                <li class="fullscreen">
                    <button mat-icon-button (click)="callFullscreen()" class=" nav-notification-icons">
                        <mat-icon>fullscreen</mat-icon>
                    </button>
                </li>
                <!-- #END# Full Screen Button -->
                
                <li class="dropdown user_profile">
                    <a href="#" onClick="return false;" data-toggle="dropdown" role="button" class="pt-0">
                        <img src="assets/images/user.jpg" class="rounded-circle" width="32" height="32" alt="User">
                    </a>
                    <ul class="dropdown-menu pullDown">
                        <li class="body">
                            <ul class="user_dw_menu">
                                <li>
                                    <a href="#" onClick="return false;">
                                        <mat-icon aria-hidden="false" class="mr-2">person</mat-icon>Profile
                                    </a>
                                </li>                              
                                <li>
                                    <a href="#" onClick="return false;">
                                        <mat-icon aria-hidden="false" class="mr-2">help</mat-icon>Help
                                    </a>
                                </li>
                                <li>
                                    <a routerLink="/authentication/signin" onClick="return false;">
                                        <mat-icon aria-hidden="false" class="mr-2">power_settings_new</mat-icon>Logout
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
                <!-- #END# Tasks -->
                <li class="pull-right">
                    <button mat-icon-button (click)="toggleRightSidebar()"
                        class="nav-notification-icons js-right-sidebar">
                        <mat-icon id="settingBtn">settings</mat-icon>
                    </button>
                </li>
            </ul>
        </div>
    </div>
</nav>